import React, {useContext} from "react";
import styles from "./topBar/TopBar.module.scss";
import ButtonWithIcon from "../Componnets/ButtonWithIcon/ButtonWithIcon";
import appContext from "../../context/appContext";

const TopBar = ({ canAddNewAnalysis, connected = false, handleShowCreateAnalysisModal, connectedDataPoolName='' }) => {

    const context = useContext(appContext);

    return (
        <div className={`${styles.TopBar} d-flex justify-content-end`}>
            <div className={styles.connection}>
                <ButtonWithIcon disabled type={'outline'}>
                    <div style={{width: 25,
                        height: 25,
                        marginLeft: -12,
                    }}>
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                             xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 512 512" style={{enableBackground: 'new 0 0 512 512'}} xmlSpace="preserve">
                            <path className={connected ? 'main-green-2' : 'red'} d="M448.779,235.5C464.04,152.252,399.905,76,316,76c-48.485,0-91.873,25.721-115.782,65.534
                                c-32.612-10.538-66.144-6.047-93.77,12.971c-27.611,19.007-44.101,49.101-45.436,82.016C24.118,253.902,0,290.638,0,331
                                c0,6.913,0.678,13.828,2.014,20.555C11.733,400.485,55.044,436,105,436h301c58.448,0,106-47.103,106-105
                                C512,289.686,486.935,252.393,448.779,235.5z M406,406H105c-41,0-75-33.235-75-75c0-31.25,20.537-59.52,51.104-70.345l10.65-3.772
                                l-0.685-11.278c-1.611-26.5,10.498-51.319,32.391-66.39c23.151-15.938,51.552-17.039,77.549-5.251l13.512,6.127l6.275-13.444
                                C237.992,129.806,275.362,106,316,106c57.897,0,105,47.103,105,105c0,17.126-3.613,27.495-7.608,41.224
                                c11.185,5.806,12.995,6.882,16.761,8.172C461.164,271.018,482,299.392,482,331C482,372.355,447.906,406,406,406z"/>
                            </svg>

                    </div>

                    <div className={styles.content}>
                        {connected ?
                            <div className="fw600 dark-gary-2">Connected to</div>
                            :
                            <div className="fw600 red">No Connection!</div>
                        }
                        <div>{ connectedDataPoolName && connectedDataPoolName.data_pool_name }</div>
                    </div>
                </ButtonWithIcon>
            </div>
            {
                (localStorage.getItem("role") === "admin" || localStorage.getItem("role") === "analyzer") &&
                    <div className={[styles.newAnalysis, (canAddNewAnalysis ? styles.disabled : '')].join(' ')}>
                        <ButtonWithIcon
                          onClick={handleShowCreateAnalysisModal}
                          disabled={!canAddNewAnalysis || context.handleLostWorkspaceDataConnector() || !context.onlineStatus || context.handleSaveAnalysisStatus() === 'error' || context.handleSaveAnalysisStatus() === 'fetching'}
                        >
                            <div>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 6.93945V13.0447" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.0556 9.99215H6.94446" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9048 1.6665H6.09526C3.37304 1.6665 1.66669 3.59324 1.66669 6.3208V13.6789C1.66669 16.4064 3.3651 18.3332 6.09526 18.3332H13.9048C16.6349 18.3332 18.3334 16.4064 18.3334 13.6789V6.3208C18.3334 3.59324 16.6349 1.6665 13.9048 1.6665Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div className="f12 fw500">New Analysis</div>
                        </ButtonWithIcon>
                    </div>
            }
        </div>
    )
}

export default TopBar;